import { render, staticRenderFns } from "./ProductsAndServices.vue?vue&type=template&id=3ddf97ca&scoped=true&"
import script from "./ProductsAndServices.vue?vue&type=script&lang=js&"
export * from "./ProductsAndServices.vue?vue&type=script&lang=js&"
import style0 from "./ProductsAndServices.vue?vue&type=style&index=0&id=3ddf97ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddf97ca",
  null
  
)

export default component.exports